import React from 'react';
import { Terminal } from 'lucide-react';

export const Loader = ({ text, fullScreen = true }) => {
  return (
    <div className={`${fullScreen ? 'min-h-screen' : 'h-96'} flex flex-col items-center justify-center gap-4 bg-background`}>
      <div className="relative flex items-center justify-center w-12 h-12 bg-card border border-border rounded-lg shadow-2xl">
        <div className="absolute inset-0 bg-primary/10 blur-md rounded-lg" />
        <Terminal className="w-5 h-5 text-primary animate-pulse relative z-10" />
      </div>
      <span className="text-[9px] font-semibold text-primary uppercase tracking-[0.4em] animate-pulse">
        {text || "Loading..."}
      </span>
    </div>
  );
};
